//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectFaceList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Lockx",1,0],[0,"Locky",1,0],[0,"Lockz",1,0],[1,"Prod",0,"SelectFaceList",0],[0,"Wcstype",1,0]],[[[],"CancelMoldCsys",{},0,0],[[],"DestroyMoldCsys",{},0,0],[[],"Initialize",{},0,0],[["csysTag"],"UpdateSelectedCsys",{},1,0],[["displayMessage","prodPart","prodBody"],"OpenOriginalProdPartQuietly",{},1,0],[[],"UpdateBodyBox",{},0,0],[["csysMatrix"],"RepositionProductPart",{},1,0]],[]];
SPLM.Tooling.MoldCsysBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.MoldCsysBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.MoldCsysBuilder.Wcsposition = Object.freeze({
    "CurrentWcs" : "CurrentWcs", "ProductBodyCenter" : "ProductBodyCenter", "BoundaryFaceCenter" : "BoundaryFaceCenter"});

export default SPLM;